"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgb = hexToRgb;
exports.rgbToHex = rgbToHex;
exports.hexToRgba = hexToRgba;
/**
 * Converts a HEX color string to RGB values
 * @param hex - The hex color string (with or without #)
 * @returns RGB object with r, g, b values (0-255) or null if invalid
 */
function hexToRgb(hex) {
    // Remove # if present
    const cleanHex = hex.replace('#', '');
    // Validate hex string
    if (!/^[0-9A-Fa-f]{6}$/.test(cleanHex)) {
        return null;
    }
    // Parse hex values
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return { r, g, b };
}
function rgbToHex(rOrRgb, g, b) {
    let r, green, blue;
    if (typeof rOrRgb === 'object') {
        r = rOrRgb.r;
        green = rOrRgb.g;
        blue = rOrRgb.b;
    }
    else {
        r = rOrRgb;
        green = g;
        blue = b;
    }
    // Validate RGB values
    if (r < 0 || r > 255 || green < 0 || green > 255 || blue < 0 || blue > 255) {
        return null;
    }
    // Convert to hex and pad with zeros if needed
    const hexR = Math.round(r).toString(16).padStart(2, '0');
    const hexG = Math.round(green).toString(16).padStart(2, '0');
    const hexB = Math.round(blue).toString(16).padStart(2, '0');
    return `#${hexR}${hexG}${hexB}`.toUpperCase();
}
/**
 * Converts a HEX color to RGBA string with specified alpha
 * @param hex - The hex color string (with or without #)
 * @param alpha - Alpha value (0-1 for transparency, where 0 is fully transparent and 1 is fully opaque)
 * @returns RGBA string like "rgba(255, 0, 0, 0.5)" or null if invalid
 */
function hexToRgba(hex, alpha) {
    // Validate alpha value
    if (alpha < 0 || alpha > 1) {
        return null;
    }
    // Convert hex to RGB first
    const rgb = hexToRgb(hex);
    if (!rgb) {
        return null;
    }
    // Return RGBA string
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}
//# sourceMappingURL=color.js.map